/**
 * SectionPanel — panel with icon-chip header, title/subtitle, optional Live
 * badge and a right-aligned action slot (e.g. a TrendButton).
 */
export default function SectionPanel({
  icon,
  title,
  subtitle,
  live = false,
  action,
  children,
  testid,
}) {
  return (
    <section className="ciso-panel" data-testid={testid}>
      <div className="flex items-start gap-[13px] mb-[18px]">
        {icon && (
          <span className="ciso-chip">
            <i className={icon} />
          </span>
        )}
        <div className="flex-1 min-w-0">
          <h3
            style={{
              margin: 0,
              fontFamily: "var(--font-display)",
              fontSize: 18,
              fontWeight: 700,
              color: "var(--ink)",
              fontVariant: "small-caps",
              letterSpacing: "0.03em",
            }}
          >
            {title}
          </h3>
          {subtitle && (
            <p className="text-[12.5px]" style={{ margin: "3px 0 0", color: "var(--text-muted)" }}>
              {subtitle}
            </p>
          )}
        </div>
        {live && (
          <span
            className="inline-flex items-center gap-[6px] ciso-cap"
            style={{
              background: "var(--success-50)",
              color: "var(--success-600)",
              borderRadius: "var(--radius-pill)",
              fontWeight: 700,
              fontSize: 12,
              padding: "2px 9px",
              whiteSpace: "nowrap",
            }}
          >
            <span className="ciso-livedot" />
            Live
          </span>
        )}
        {action}
      </div>
      {children}
    </section>
  );
}
